import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scroll behaviour for SPA navigation.
 * - When the URL has a hash (e.g. `/donation-partage#definition`), smoothly
 *   scroll the matching element into view with a 24px offset.
 * - When there is no hash, reset scroll to the top — otherwise React Router
 *   keeps the previous scroll position which feels broken on long pages.
 *
 * Mount this once inside <BrowserRouter> in App.js.
 */
const ScrollToHash = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Wait one frame so the new route has rendered and the element exists.
      const id = hash.slice(1);
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          const top = el.getBoundingClientRect().top + window.pageYOffset - 24;
          window.scrollTo({ top, behavior: 'smooth' });
          return true;
        }
        return false;
      };
      if (!tryScroll()) {
        // Element not yet mounted — retry shortly.
        const t = setTimeout(tryScroll, 80);
        return () => clearTimeout(t);
      }
    } else {
      window.scrollTo({ top: 0, behavior: 'auto' });
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToHash;
